// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3lWCa","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3YKSn","obliqueLine":"membershipbadge_obliqueLine__2ndK4"};